import React from "react";
import "./Animal.css"
import { Link } from "react-router-dom";

const image = require('../assets/ace.jpeg');


function Animal({ animal }) {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');

    return (
        <>
            <section className="section">
                <div className="profile">
                    <img className="animalProfile" src={animal[id].imageUrl} alt={animal[id].name}></img>
                </div>
                <div className="description">
                    <h1>{animal[id].name}</h1>
                    <br/>
                    <li><span>Gender:</span> {animal[id].gender}</li>
                    <li><span>Age:</span> {animal[id].age}</li>
                    <li><span>Breed:</span> {animal[id].breed}</li>
                    <li><span>Color:</span> {animal[id].color}</li>
                    <br />
                    {animal[id].description}
                    <br />
                    <br />
                    <Link to={`/adoptform?id=${animal[id].id}`}>
                        <button>Adopt Me!</button>
                    </Link>
                </div>
            </section>
        </>
    )
}

export default Animal;